export default __webpack_public_path__ + "static/media/_water.9ff0be8b.png";